import router from './router'
import utils from '@/utils/utils'
import constant from '@/api/constant.js'
import secret from './utils/secret'
import store from './store'
import { Toast } from 'vant';
import Vue from 'vue';
Vue.use(Toast);
import {
  getUserToken,
  setToken,
} from '@/utils/cookies'
import {
  findProductCode
} from '@/api/resources'
import {
  getFindAppByCode
} from '@/api/publishOnline'
const PLATFORM_PATH = process.env.PLATFORM_PATH
const SSO_WEB_URL = process.env.SSO_WEB_URL
const JGSSO_WEB_URL = process.env.JGSSO_WEB_URL
const READ_PLATFORM_PATH = process.env.READ_PLATFORM_PATH
let previousUrl
router.beforeEach((to, from, next) => {
    
  if (to.matched.length === 0) {
    next()
  } else {
    //获取到上个页面传过来的地址
    var url = window.location;
    var baseUrl = url.origin + url.pathname + "?";
    var query = url.search.slice(1);
    if (query.indexOf('purl')>-1) {
      var obj = {}
      var arr = query.split("&");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=");
        obj[arr[i][0]] = arr[i][1];
      };
      previousUrl = obj['purl']
      //删除上个页面传过了的地址
      delete obj['purl'];
      //url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&");
      url = baseUrl + Object.keys(obj).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])).join('&');
      console.log('sssd111',previousUrl,url)
      //获取到之后存入当前会话  为了复制当前url不携带上个页面传过的地址
      window.sessionStorage.setItem('previousUrl',previousUrl)
      window.location.href = url
    }else{
    //  if(window.sessionStorage.getItem('previousUrl'),'PC'){
    //   previousUrl = window.sessionStorage.getItem('previousUrl'),'PC'
    //   console.log('sssd2222',previousUrl)
    //   window.sessionStorage.removeItem("previousUrl");
    //  }
    };
    let toquery = to.query
    let token = toquery.token;
    if (token) {
      setToken(token)
    } else {
      token = getUserToken();
    }
    if(toquery.adminToken){
      sessionStorage.setItem('adminToken', toquery.adminToken);
    }


    // var urlToken = to.query.token
    let toMeta = to.meta
    // let toPath = to.path
    let jumpAuth = toMeta.jumpAuth // 是否个人中心跳转
    // let requireAuth = toMeta.requireAuth
    // console.log('from', from)

    // if (utils.isNotEmpty(urlToken)) {
    //   setToken(urlToken)
    // }
    const userToken = getUserToken()
    // if (requireAuth && !isLogin) {
    //   window.location.href = `${SSO_WEB_URL}/login${params}`
    // }
    let existLogin;
    if (utils.isNotEmpty(userToken) && userToken != 'null') {
      existLogin = utils.isNotEmpty(userToken)
      let theAppCode = to.query.appCode
      /** 获取商品信息 */
      let params1 = {
        productCode: to.query.productCode
      }
      //不知道以前为啥每个路径都调用findProductCode获取商品接口  但是以下路径不需要请求这个接口
      // if(to.path == '/placeOrder' || to.path == '/cashier' || to.path == '/aliPay' || to.path == '/invlist' || to.path == '/addInv' || to.path == '/paySuccess'){
      //   console.log('不需要调获取商品信息')
      // }else{
      //   findProductCode(params1).then(res => {
      //     var isBranch = ''
      //     if(res.data.errorInfo != 'success'){
      //       Toast(res.data.otherData);
      //     }else{
      //     if (res.data.data.productInfo.appCode == 'sztsg') {
      //       sessionStorage.setItem('isBranch', true)
      //     } else {
      //       sessionStorage.setItem('isBranch', false)
      //     }
      //     if (res.data.data.userAuthority == 'whole') {
      //       sessionStorage.setItem('isReadPower', true)
      //     } else {
      //       sessionStorage.setItem('isReadPower', false)
      //     }
      //     }
      //   })
      // }
      if (theAppCode == 'sztsg') {
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          var targetUrl = JGSSO_WEB_URL + '/mobileLogin'
        } else {
          var targetUrl = JGSSO_WEB_URL + '/login'
        }
      } else {
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          var targetUrl = SSO_WEB_URL + '/mobileLogin'
        } else {
          var targetUrl = SSO_WEB_URL + '/login'
        }
      }

      console.log('tototo', to)
      const isLogin = store.getters.isLogin
      store.commit('setIsCourse', (utils.isNotEmpty(toMeta.isCoures)) && toMeta.isCoures ? true : false)
      let paramsStr = ''
      let paramsRedirectUrl = 'redirectUrl=' + secret.encryptionText(READ_PLATFORM_PATH + to.fullPath) + paramsStr
      let params = '?' + paramsRedirectUrl // 回调路径参数
      let targetFullUrl = (isLogin && jumpAuth) ? targetUrl : targetUrl + params



      if (theAppCode == 'sztsg') {
        // alert(2)
        store.dispatch('getUserInfo').then(res => {
          // alert(3)
          // alert(JSON.stringify(res))
          if (res.errorInfo == 'success' && res.data != null) {
            console.log('resresres234',res)
            // alert(1)
            next()
          } else {
            store.dispatch('getUserBranchInfo').then(res => {
              console.log('resresres',res)
              if (res && res.data != null) {
                next()
              } else {
                //该机构阅读时不跳转登录 未登录也可以试读
                if(to.query.outstation && (to.query.outstation.split(',')[0] == 'bjbwz' || to.query.outstation.split(',')[0] == 'zjb')){
                  next()
                }else{
                  window.location.href = targetFullUrl
                }
              }
            })
          }
        })
      }
      if (theAppCode != 'sztsg') {
        store.dispatch('getUserInfo').then(res => {
          if (res.errorInfo == 'success' && res.data != null) {
            next()
          } else {
            //新需求 ： 未登录也可以试读
            //window.location.href = targetFullUrl
            next()
          }
          console.log('resresresresresres236', res)
        })
      }
    } else {
      sessionStorage.setItem('theAppCode', to.query.appCode)
      // alert('没token，存一下')
      store.dispatch('findToken').then(res => {
        setToken(res.data.data)
        window.location.href = process.env.READ_PLATFORM_PATH + to.fullPath
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js